import { graphql } from '@/generated/gql';

export const GET_RULE_BUIDER_BACKEND_DATA = graphql(/* GraphQL */ `
  query GetRuleRuleBuilderBackendData($id: UUID!) {
    tesseract {
      rule(id: $id) {
        id
        variant
        ruleVersion {
          id
          status
          graph
          stats {
            id
            edges {
              itemId
              hits
            }
            nodes {
              itemId
              hits
            }
          }
        }
      }
    }
  }
`);
